import React, { useCallback } from "react";
import { RapButton } from "@dynata/rex-raptor";
import { useSubmit } from "react-router-dom";
import { Role } from "models/user";
import paths from "paths";

type UserAccountRecordProps = {
  role: Role;
};

const UserAccountRecord: React.FC<UserAccountRecordProps> = ({ role }) => {
  const submit = useSubmit();

  const path = role.isAdhoc
    ? paths.authenticated.PROJECTS
    : paths.authenticated.DASHBOARD;

  const onClickAccount = useCallback(() => {
    submit(null, { method: "get", action: `${role.accountNumber}/${path}` });
  }, [role.accountNumber]);

  return (
    <tr>
      <td>
        <RapButton
          styleType="link"
          size="small"
          color="main"
          onClick={onClickAccount}
        >
          {role.accountName}
        </RapButton>
      </td>
    </tr>
  );
};

export default UserAccountRecord;
